import React, { ReactElement } from 'react';
import { useCommon } from 'src/AppState/Common';
import { REWARD_CONDITIONS_ROOT } from 'src/domains/casino/utils/test-variables';
import { BonusCreationState } from 'src/domains/casino/webview/bonus-engine/bonus-creator/bonus-creation/BonusCreation.state';
import { CasinoSection } from 'src/domains/casino/webview/bonus-engine/bonus-creator/bonus-creation/reward-conditions/casino-section/CasinoSection';
import { SportsBookSection } from 'src/domains/casino/webview/bonus-engine/bonus-creator/bonus-creation/reward-conditions/sportsbook-section/SportsBookSection';
import { Input } from 'src/domains/common/components/input/input';
import { Select } from 'src/domains/common/components/select/select';
import { observer } from 'src/utils/mobx-react';

interface RewardConditionsPropsType {
    bonusCreationId?: string;
}

export const RewardConditions = observer(
    'RewardConditions',
    ({ bonusCreationId }: RewardConditionsPropsType): ReactElement => {
        const common = useCommon();
        const { rewardConditionsState, editionDisabled } = BonusCreationState.get(common, bonusCreationId);
        return (
            <div
                className='grid grid-cols-2'
                data-test={REWARD_CONDITIONS_ROOT}
            >
                <div className='flex flex-col gap-8'>
                    <section className='flex flex-col gap-6'>
                        <h2 className='m-0 text-[1rem] font-semibold leading-[1.75]'>General Information</h2>

                        <div
                            data-test='reward-type'
                            className='flex flex-col gap-4'
                        >
                            <Select
                                dataTest='reward-type-dropdown'
                                description='Select Reward Type to display relevant condition form'
                                formInputState={rewardConditionsState.bonusTypeForm}
                                label='Reward Type'
                                placeholder='Select'
                                values={rewardConditionsState.allRewardOptions}
                                errors={rewardConditionsState.bonusTypeForm.errorsForView}
                                disabled={editionDisabled}
                            />

                            <Input
                                description='Enter a maximum of 30 Characters'
                                formInputState={rewardConditionsState.rewardNameForm}
                                label='Reward Name'
                                placeholder='Type'
                                errors={rewardConditionsState.rewardNameForm.errorsForView}
                                disabled={editionDisabled}
                            />
                        </div>
                    </section>

                    {rewardConditionsState.selectedRewardType === 'free-bet' && (
                        <SportsBookSection bonusCreationId={bonusCreationId} />
                    )}

                    {rewardConditionsState.selectedRewardType === 'free-spin' && (
                        <CasinoSection bonusCreationId={bonusCreationId} />
                    )}
                </div>
            </div>
        );
    }
);
